import gql from "graphql-tag";

export const DASHBOARD_BENEFICIO = gql`
  query DashboardSolicitud(
    $historico: String!
    $fecha_inicio: String!
    $fecha_final: String!
  ) {
    DashboardSolicitud(
      historico: $historico
      fecha_inicio: $fecha_inicio
      fecha_final: $fecha_final
    ) {
      total_beneficiados
      total_solicitudes
      solicitudes_tipo {
        id_tipo
        nombre_solicitud
        descripcion
        url_imagen
        cantidad_solicitudes
        porcentaje_solicitudes
      }
      solicitudes_estado {
        id_estado_solicitud
        nombre
        descripcion
        color
        cantidad_solicitudes
        porcentaje_solicitudes
      }
    }
  }
`;

export const LIST_ADMIN_BENEFICIO = gql`
  query ListSolicitudesAdmin(
    $id_empresa: String!
    $id_tipo_solicitud: String!
    $historico: String!
    $fecha_inicio: String!
    $fecha_final: String!
    $nombre_usuario: String!
    $id_estado: String!
  ) {
    ListSolicitudesAdmin(
      id_empresa: $id_empresa
      id_tipo_solicitud: $id_tipo_solicitud
      historico: $historico
      fecha_inicio: $fecha_inicio
      fecha_final: $fecha_final
      nombre_usuario: $nombre_usuario
      id_estado: $id_estado
    ) {
      id_solicitud
      codigo_solicitud
      nombre
      descripcion
      fecha_creacion
      estado_solicitud {
        id_estado_solicitud
        nombre
        descripcion
        color
      }
      detalle_solicitud {
        id_solicitud_detalle
        nombre
        descripcion
        cantidad_solicitada
        cantidad_modificada
        cantidad_entregada
        inventario {
          id_inventario
          codigo_inventario
          nombre
          descripcion
          cantidad_inicial
          cantidad_actual
          con_limite
          limite_cantidad
          con_detalle
        }
        inventario_detalle {
          id_detalle
          nombre_detalle
          descripcion
          tipo_detalle
          editable
          id_formulario_fk
          codigo_detalle
        }
        valores_formulario {
          id_valor
          valor
          formulario_selector {
            id_formulario
            nombre
            tipo_dato
            con_valor_predeterminado
            is_selector
            nombre_header
          }
        }
      }
      usuario {
        id_usuario
        primer_nombre
        segundo_nombre
        apellido_paterno
        apellido_materno
        rut_usuario
        dv_usuario
        imagen_perfil
        fecha_ingreso
        cargo {
          id_cargo
          nombre_cargo
        }
      }
      tipo_solicitud {
        id_tipo
        nombre_solicitud
        descripcion
        url_imagen
        datos_formulario {
          id_formulario
          nombre
          tipo_dato
          con_valor_predeterminado
          informacion_usuario
          is_selector
          is_admin

          datos_selector_empresa {
            id_dato_selector
            nombre
            descripcion
            id_formulario_dato_fk
          }
          datos_selector_inventario {
            id_detalle
            nombre_detalle
            descripcion
            tipo_detalle
            editable
            id_formulario_fk
            codigo_detalle
          }
          datos_selector_producto {
            id_inventario
            codigo_inventario
            nombre
            descripcion
            cantidad_inicial
            cantidad_actual
            con_limite
            limite_cantidad
            con_detalle
            detalles_inventario {
              id_detalle
              nombre_detalle
              descripcion
              tipo_detalle
              editable
              id_formulario_fk
              codigo_detalle
            }
          }
        }
      }
    }
  }
`;

export const ELEMENTS_TIPOS_SOLICITUD = gql`
  query ListarAllElementsTiposSolicitudAdmin(
    $id_tipo_solicitud: String!
  ) {
    ListarAllElementsTiposSolicitudAdmin(
      id_tipo_solicitud: $id_tipo_solicitud
    ) {
      id_tipo
      nombre_solicitud
      descripcion
      url_imagen
      datos_formulario {
        id_formulario
        nombre
        tipo_dato
        con_valor_predeterminado
        informacion_usuario
        is_selector
        is_admin
        datos_selector_empresa {
          id_dato_selector
          nombre
          descripcion
          id_formulario_dato_fk
        }
        datos_selector_inventario {
          id_detalle
          nombre_detalle
          descripcion
          tipo_detalle
          editable
          id_formulario_fk
          codigo_detalle
        }
        datos_selector_producto {
          id_inventario
          codigo_inventario
          nombre
          descripcion
          cantidad_inicial
          cantidad_actual
          con_limite
          limite_cantidad
          con_detalle
          detalles_inventario {
            id_detalle
            nombre_detalle
            descripcion
            tipo_detalle
            editable
            id_formulario_fk
            codigo_detalle
          }
        }
      }
      datos_inventario {
        id_inventario
        codigo_inventario
        nombre
        descripcion
        cantidad_inicial
        cantidad_actual
        con_limite
        limite_cantidad
        con_detalle
      }
      usuario {
        id_usuario
        primer_nombre
        segundo_nombre
        apellido_paterno
        apellido_materno
        rut_usuario
        dv_usuario
        correo
        telefono_movil
      }
    }
  }
`;

export const LIST_PAGINADA_SOLICIUDES = gql`
  query ListSolicitudesAdminById(
    $id_tipo_solicitud: String!
    $id_solicitud: [String!]
  ) {
    ListSolicitudesAdminById(
      id_tipo_solicitud: $id_tipo_solicitud
      id_solicitud: $id_solicitud
    ) {
      id_solicitud
      codigo_solicitud
      nombre
      descripcion
      fecha_creacion
      estado_solicitud {
        id_estado_solicitud
        nombre
        descripcion
        color
      }
      detalle_solicitud {
        id_solicitud_detalle
        nombre
        descripcion
        cantidad_solicitada
        cantidad_modificada
        cantidad_entregada
        inventario {
          id_inventario
          codigo_inventario
          nombre
          descripcion
          cantidad_inicial
          cantidad_actual
          con_limite
          limite_cantidad
          con_detalle
        }
        inventario_detalle {
          id_detalle
          nombre_detalle
          descripcion
          tipo_detalle
          editable
          id_formulario_fk
          codigo_detalle
        }
        valores_formulario {
          id_valor
          valor
          formulario_selector {
            id_formulario
            nombre
            tipo_dato
            con_valor_predeterminado
            is_selector
            nombre_header
          }
        }
      }
      usuario {
        id_usuario
        primer_nombre
        segundo_nombre
        apellido_paterno
        apellido_materno
        rut_usuario
        dv_usuario
        imagen_perfil
        fecha_ingreso
        cargo {
          id_cargo
          nombre_cargo
        }
      }
      tipo_solicitud {
        id_tipo
        nombre_solicitud
        descripcion
        url_imagen
        datos_formulario {
          id_formulario
          nombre
          tipo_dato
          con_valor_predeterminado
          informacion_usuario
          is_selector
          is_admin

          datos_selector_empresa {
            id_dato_selector
            nombre
            descripcion
            id_formulario_dato_fk
          }
          datos_selector_inventario {
            id_detalle
            nombre_detalle
            descripcion
            tipo_detalle
            editable
            id_formulario_fk
            codigo_detalle
          }
          datos_selector_producto {
            id_inventario
            codigo_inventario
            nombre
            descripcion
            cantidad_inicial
            cantidad_actual
            con_limite
            limite_cantidad
            con_detalle
            detalles_inventario {
              id_detalle
              nombre_detalle
              descripcion
              tipo_detalle
              editable
              id_formulario_fk
              codigo_detalle
            }
          }
        }
      }
    }
  }
`;

export const PAGINA_LIST_BENEFICIOS = gql`
  query PaginasSolicitudesAdmin(
    $id_tipo_solicitud: String!
    $historico: String!
    $fecha_inicio: String!
    $fecha_final: String!
    $nombre_usuario: String!
    $id_estado: String!
    $limite: String!
  ) {
    PaginasSolicitudesAdmin(
      id_tipo_solicitud: $id_tipo_solicitud
      historico: $historico
      fecha_inicio: $fecha_inicio
      fecha_final: $fecha_final
      nombre_usuario: $nombre_usuario
      id_estado: $id_estado
      limite: $limite
    ) {
      pagina
      solicitudes
      total
    }
  }
`;

// Settings beneficios
// ListTipoPeriodos, ListTipoCondiciones, findPeriodosCondicionesEmpresa
export const [LIST_TIPO_PERIODOS, LIST_TIPO_CONDICIONES, FIND_PERIODOS_CONDICIONES_EMPRESA] = [
  gql`query ListTipoPeriodos {
  ListTipoPeriodos {
    id_tipo
    nombre
    is_dia
    is_rango
    is_transversal
  }
}`,
  gql`query ListTipoCondiciones {
  ListTipoCondiciones {
    id_tipo
    nombre
    campo_bd
    is_transversal
  }
}`,
  gql`query findPeriodosCondicionesEmpresa {
  findPeriodosCondicionesEmpresa {
    id_solicitud_empresa
    nombre
    descripcion
    id_tipo_solicitud_fk
    solicitud_tipo {
      id_tipo
      nombre_solicitud
      descripcion
      url_imagen
    }
    periodos {
      id_periodo
      nombre
      descripcion
      tipo_tiempo
      tiempo_inicio
      tiempo_final
      tiempo_dia
      tipo {
        id_tipo
        nombre
        is_dia
        is_rango
        is_transversal
      }
    }
    condiciones {
      id_condicion
      c_area
      c_ingreso_desde
      c_ingreso_hasta
      c_genero
      c_nacimiento_desde
      c_nacimiento_hasta
      id_solicitud_empresa_fk
      id_tipo_fk
      id_empresa_fk
      tipo {
        id_tipo
        nombre
        campo_bd
        is_transversal
      }
    }
  }
}`]
